module.exports = __webpack_public_path__ + "media/markers/marker-red-9d444a89.svg";